import { useState, useEffect, useMemo } from "react";

import styled from "styled-components";
import axios from "axios";
import { ImArrowLeft, ImArrowRight } from "react-icons/im";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo1 from "../../../styles/imagem/logo-1.png";
import logo6 from "../../../styles/imagem/logo-6.png";
import { FaDownload } from "react-icons/fa";


const Container = styled.div`
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
`;


const Td3 = styled.td`
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 10px 0px;
  align-items: center;

  span{
    margin: 0px 5px;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; 
    text-align: center;
    gap: 15px;
  }

`;

const Input = styled.input`
  width: 380px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;
  @media (max-width: 768px) {
    width: 90%;
      
  }
`;

const Select = styled.select`
  width: 250px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Button = styled.button`
  cursor: pointer;
  border: none;
  color: #575757;
  background-color: transparent;
  transition: transform 0.1s;
  font-size: medium;
  font-weight: bold;
  &:hover {
    transform: scale(1.3);
  }
`;
const Button2 = styled.button`
  cursor: pointer;
  border: none;
  color: #575757;
  background-color: transparent;
  transition: transform 0.1s;
  font-size: x-large;
  font-weight: bold;
  &:hover {
    transform: scale(1.3);
  }
`;

const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content:center;

  span{
    padding: 0px  10px;
  }
`;
const Div5 = styled.div`
  display: flex;
  align-items: center;
  justify-content:center;
  gap: 50px;
  span{
    padding: 0px  10px;
  }


    @media (max-width: 768px) {
      width: 80%;
      display: flex;
      justify-content: space-between;
    }
`;

const Div6 = styled.div`
  display: flex;
  align-items: center;
  justify-content:center;
  gap: 50px;
  span{
    padding: 0px  10px;
  }


    @media (max-width: 768px) {
      width: 90%;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content:space-between;
      gap: 20px
    }
`;


const Div3 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;


const Div4 = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 16px 24px;
  box-sizing: border-box;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;



  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;

    button {
      align-self: stretch;
      margin-top: 12px;
    }
  }
`;
const H2 = styled.h2`
  font-size: 18px;
  color: #333;
  margin: 0 0 8px 0;
`;


const ServicosLista = styled.div`
  background-color: #f5f5f5;
  margin: 0px 0 20px 0;
  padding: 15px;
  border-radius: 0px 0px 8px 8px;
`;

const ServicoItem = styled.div`
  padding: 10px;
  border-bottom: 1px solid #ddd;

  &:last-child {
    border-bottom: none;
  }

  p {
    margin: 4px 0;
    font-size: 16px;
  }

  div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

const Container2 = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column; // <- força em coluna no mobile
  }
`;

const Item = styled.p`
  flex: 1;

  @media (max-width: 768px) {
    flex: unset;         // remove o "flex: 1"
    width: 100%;         // ocupa a linha inteira
    margin: 0;           // zera margem padrão se quiser
  }
`;

const ServicosWrapper = styled.div`
  max-height: ${({ expandido }) => (expandido ? '500px' : '0')};
  overflow: hidden;
  transition: max-height 0.5s ease;
`;
const Div7 = styled.div`
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;

  }
`;
const Div8 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;


`;

const Div9 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;


`;
const Grid = ({ osPatio, urlApi, tipoPatio, totalOsPatio }) => {

  const token = localStorage.getItem('token');

  //---------------------------------------FUNÇÂO DE PESQUISA---------------------------------------------------//

  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState(osPatio);
  const [isLoading, setIsLoading] = useState(true);
  const [tipoSelecionado, setTipoSelecionado] = useState('');


  //Input de pesquisa
  const handleSearch = async (term) => {
    setIsLoading(true);

    try {
      const filtered = osPatio.filter((user) => {
        const ordem_servico = (user.NUMERO_ORDEMSERVICO || '').toString().toLowerCase();
        const objeto = (user.COD_EQUIPAMENTO || '').toString().toLowerCase();
        const descricao = (user.DESCRICAO || '').toString().toLowerCase();

        const passaFiltroPesquisa =
          ordem_servico.includes(term.toLowerCase()) ||
          objeto.includes(term.toLowerCase()) ||
          descricao.includes(term.toLowerCase());

        const passaFiltroTipo =
          tipoSelecionado === '' || user.COD_TIPOEQUIPAMENTO === parseInt(tipoSelecionado, 10);

        return passaFiltroPesquisa && passaFiltroTipo;
      });

      setFilteredUsers(filtered);
    } catch (error) {
      console.error("Erro ao pesquisar:", error);
    }

    setCurrentPage(1);
    setIsLoading(false);
  };



  useEffect(() => {
    handleSearch(searchTerm);
  }, [searchTerm, osPatio, , tipoSelecionado]);

  //---------------------------------------------ORDENAÇÂO DA PAGINA-----------------------------------------------------------------//
  //Paginação
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;


  // Estado para Ordenação
  const [sortConfig, setSortConfig] = useState(null);

  // Função de Ordenação (agora aplicada ANTES da paginação)
  const sortedData = useMemo(() => {
    let sortableData = [...filteredUsers];

    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        const aValue = sortConfig.key.split('.').reduce((o, i) => o[i], a);
        const bValue = sortConfig.key.split('.').reduce((o, i) => o[i], b);

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableData;
  }, [filteredUsers, sortConfig]);

  //---------------------------------------EFEITO DE PAGINACAO---------------------------------------------------//

  //Paginação
  // Defina a quantidade de itens por página conforme necessário
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  // Função para ir para a próxima página
  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  // Função para ir para a página anterior
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };






  //---------------------------------------RETORNA O SERVICO POR EQUIPAMENTO---------------------------------------------------//

  const [servicosPorOS, setServicosPorOS] = useState({});
  const [osExpandida, setOsExpandida] = useState(null);





  useEffect(() => {
    const carregarTodosServicos = async () => {
      try {
        const response = await axios.get(`${urlApi}acompanhamento-os/listar-servico-patio`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        // Agrupando por Numero_Ordem
        const agrupado = response.data.reduce((acc, item) => {
          const numero = item.Numero_Ordem;
          if (!acc[numero]) acc[numero] = [];
          acc[numero].push(item);
          return acc;
        }, {});

        setServicosPorOS(agrupado);
      } catch (error) {
        console.error("Erro ao buscar serviços:", error);
      }
    };

    carregarTodosServicos();
  }, []);


  //=======================GERAR PDF==========================================//

  const getBase64FromImage = (imgSrc) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        resolve({
          base64: canvas.toDataURL("image/png"),
          width: img.naturalWidth,
          height: img.naturalHeight,
        });
      };
      img.onerror = () => reject(new Error("Erro ao carregar imagem"));
      img.src = imgSrc;
    });
  };

  const exportarPDF = async () => {
    const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "A4" });

    // Marca d’água - já convertida aqui
    const { base64: marcaDaguaBase64, width: mw, height: mh } = await getBase64FromImage(logo1);
    const marcaW = 400;
    const marcaH = (mh / mw) * marcaW;
    const marcaX = (doc.internal.pageSize.getWidth() - marcaW) / 2;
    const marcaY = (doc.internal.pageSize.getHeight() - marcaH) / 2;

    // Cabeçalho fixo (logo)
    const { base64, width, height } = await getBase64FromImage(logo6);
    const maxW = 200, maxH = 60;
    const logoRatio = Math.min(maxW / width, maxH / height);
    const displayW = width * logoRatio;
    const displayH = height * logoRatio;

    doc.addImage(base64, 'PNG', 20, 10, displayW, displayH);
    doc.setFontSize(12);
    doc.setTextColor(87, 87, 87);
    doc.text("Relatório de OS - Pátio", 50, 70);
    doc.text(`Relatório gerado: ${new Date().toLocaleString("pt-BR")}`, 580, 70);

    // Estilo fixo para as colunas do cabeçalho
    const colunasCabecalho = {
      0: { cellWidth: 250 },
      1: { cellWidth: 350 },
      2: { cellWidth: 160 },
    };

    // Marca d’água aplicada em todas as páginas
    const drawMarcaDagua = () => {
      doc.setGState(new doc.GState({ opacity: 0.08 }));
      doc.addImage(marcaDaguaBase64, 'JPEG', marcaX, marcaY, marcaW, marcaH);
      doc.setGState(new doc.GState({ opacity: 1 }));
    };

    // Garante a marca d'água em todas as páginas
    doc.setPage(1);
    drawMarcaDagua();

    // Cada vez que uma nova página é criada, insere marca d'água
    doc.internal.events.subscribe('addPage', () => {
      drawMarcaDagua();
    });

    // Renderiza OS
    Object.entries(servicosPorOS)
      .sort(([, a], [, b]) => {
        const codA = Number(a[0]?.Cod_Equipamento ?? 0);
        const codB = Number(b[0]?.Cod_Equipamento ?? 0);
        return codA - codB;
      })

      .forEach(([numeroOS, servicos]) => {
        const primeiraTarefa = servicos[0];

        autoTable(doc, {
          startY: doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 90,
          head: [[
            `OS: ${numeroOS}`,
            `Frota: ${primeiraTarefa.Cod_Equipamento || ""} - ${primeiraTarefa.Desc_Equipamento || ""}`,
            `Data: ${new Date(primeiraTarefa.Data_Abertura).toLocaleString("pt-BR")}`
          ]],
          body: [],
          theme: "grid",
          styles: { fontStyle: 'bold', halign: 'left' },
          headStyles: { fillColor: [7, 99, 51], textColor: 255 },
          columnStyles: colunasCabecalho,
        });

        autoTable(doc, {
          startY: doc.lastAutoTable.finalY,
          head: [["Tarefa", "Tipo", "Causa", "Destino"]],
          body: servicos.map(servico => [
            servico.Tarefa,
            servico.Desc_Tipo,
            servico.Desc_Causa,
            servico.Desc_Destino
          ]),
          styles: {
            fontSize: 6,
            textColor: '#333',
            fillColor: false,
            lineColor: [200, 200, 200],
          },
          headStyles: {
            fillColor: false,
            textColor: '#333',
            fontStyle: 'bold'
          },
          columnStyles: {
            0: { cellWidth: 180 },
            1: { cellWidth: 100 },
            2: { cellWidth: 150 },
            3: { cellWidth: 120 },
          },
          theme: "plain"
        });
      });

    doc.save(`relatorio_de_os_patio_${new Date().toLocaleString("pt-BR")}.pdf`);
  };

  return (



    <Container>
      <Td3>

        <Div6>
          <Select
            value={tipoSelecionado}
            onChange={(e) => setTipoSelecionado(e.target.value)}
          >
            <option value="">Todos os tipos</option>
            {tipoPatio.map((tipo) => (
              <option key={tipo.COD_TIPOEQUIPAMENTO} value={tipo.COD_TIPOEQUIPAMENTO}>
                {tipo.DESC_TIPOEQUIPAMENTO}
              </option>
            ))}
          </Select>
          <Input
            type="text"
            placeholder="Pesquisar... Ex: OS, frota ou descrição"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Div6>


        <Div5>
          <Div>
            <Button onClick={handlePrevPage} disabled={currentPage === 1}>
              <ImArrowLeft size={20} />
            </Button>
            <span><strong>{currentPage}</strong> de <strong>{totalPages}</strong></span>
            <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
              <ImArrowRight size={20} />
            </Button>
          </Div>

          <Button2 onClick={exportarPDF} placeholder="Imprimir">
            <FaDownload />
          </Button2>
        </Div5>
      </Td3>

      <Div3>
        <Div4>
          <Div8>

            <Div9>
              <H2>Total de Ordens de Serviço Abertas:</H2>
              <H2>{totalOsPatio[0]?.TOTAL_ORDENS}</H2>

            </Div9>
          </Div8>
        </Div4>
        {currentItems.map((item, i) => {
          const servicos = servicosPorOS[item.NUMERO_ORDEMSERVICO] || [];

          return (
            <div key={i}>
              <Div4>
                <Div8>
                  <H2>{item.COD_EQUIPAMENTO} - {item.DESCRICAO}</H2>
                  <Div7>
                    <p><strong>OS:</strong> {item.NUMERO_ORDEMSERVICO}</p>
                    <p><strong>Data:</strong> {item.DATA_FORMATADA}</p>
                    <p><strong>Tempo Decorrido:</strong> {item.TEMPO_DECORRIDO}</p>
                  </Div7>
                </Div8>

                <Button onClick={() =>
                  setOsExpandida(prev => prev === item.NUMERO_ORDEMSERVICO ? null : item.NUMERO_ORDEMSERVICO)
                }>
                  {osExpandida === item.NUMERO_ORDEMSERVICO ? 'Ocultar' : 'Ver serviços'}
                </Button>

              </Div4>


              <ServicosWrapper expandido={osExpandida === item.NUMERO_ORDEMSERVICO}>
                <ServicosLista>
                  {(servicosPorOS[item.NUMERO_ORDEMSERVICO] || []).length === 0 ? (
                    <p>Nenhum serviço encontrado.</p>
                  ) : (
                    servicosPorOS[item.NUMERO_ORDEMSERVICO].map((servico, idx) => (
                      <ServicoItem key={idx}>
                        <p><strong>Tarefa:</strong> {servico.Tarefa}</p>
                        <Container2>
                          <Item><strong>Tipo:</strong> {servico.Desc_Tipo}</Item>
                          <Item><strong>Causa:</strong> {servico.Desc_Causa}</Item>
                          <Item><strong>Destino:</strong> {servico.Desc_Destino}</Item>
                        </Container2>
                      </ServicoItem>
                    ))
                  )}
                </ServicosLista>
              </ServicosWrapper>


            </div>
          );
        })}
      </Div3>


    </Container>

  );
};


export default Grid;
